// extracted by mini-css-extract-plugin
module.exports = {"logoSearLine":"logoSearLine-2FwwUpTS","logoBox":"logoBox-1cFhVNFw","logo":"logo-3F3e8ijn","subLogo":"subLogo-2uWNWPKN","wide":"wide-3-Bo-OX7","label":"label-YZ6PqP49"};